export default "__VITE_ASSET__104b871d__"